import { ApplicationRef, Inject, Injectable, isDevMode, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { MapToGA4 } from 'src/business/Mapper/map-to-ga4-item';
import { CheckoutConfiguration } from 'src/business/models/main-configuration.model';
import { PromiseUtils } from 'src/business/promise.util';
import { AddBasketLineItemsModel, AddLineItemModel, BasketClient, BasketResponseModel, BasketReturnModel, InvoiceDetailRequestModel, LineItemReturnModel, LineItemSelectedVariantOption, LinesClient, Money, NewsletterClient, NewsletterPostBody, OrderClient, Origin, PaymentMethod as PaymentMethodModel, PaymentReturnModel, PaymentTerms, PickupPoint, Price, SetCustomerTypeRequestBody, ShipmentReturnModel, ShippingMethodReturnModel, UpdateBasketAddressModel, UpdateShippingModel } from 'src/business/services/client.generated';
import { countriesMock, ICountry } from 'src/commerce/countries.mock';
import { BASE_URL, LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { GOOGLE_MAPS_API_KEY } from 'src/externals/google-maps/tokens';
import { GA4 } from 'src/externals/tag-manager/models/ga4.model';
import { SerializerUtil } from 'src/utils/serializer.util';
import { UrlUtil } from 'src/utils/url.util';

export interface PaymentMethod extends Partial<PaymentMethodModel> { name?: string; image?: string; };
export type PaymentMethods = Array<PaymentMethod>;
// export class ExtrasFormGroup extends FormGroup {

//     getExtras(): string[] {
//         const extras = [];
//         Object
//             .keys(this.value)
//             .forEach(controlKey => this.value[controlKey] === true ? extras.push(controlKey) : null);
//         return extras;
//     }
// }

// export class BasketLineForm extends FormGroup implements LineItemReturnModel {
//     private _subscriptions: Subscription[];

//     googleProductCategory: string;
//     imageUrl: string;
//     productUrl: string;
//     parentId?: string;
//     ean: string;
//     unitPrice: Price;
//     totalPrice: Price;
//     id: string;
//     sku: string;
//     name: string;
//     quantity: number;
//     brand?: string;
//     discountSplash: IDiscountSplash;
//     designer?: string;
//     splash: IDiscountSplash;
//     variantOptions: LineItemSelectedVariantOption[];


//     constructor(model: LineItemReturnModel, public addons: LineItemReturnModel[], private _basketService: BasketService, private _detector: ChangeDetectorRef) {
//         super({
//             id: new FormControl(model.id),
//             sku: new FormControl(model.sku),
//             quantity: new FormControl(model.quantity ?? 1),
//             remove: new FormControl(false),
//         });
//         this._subscriptions = [];
//         Object.assign(this, model);
//         this._subscribe();
//     }

//     private _subscribe() {
//         this._subscriptions.push(this.valueChanges
//             .pipe(
//                 debounceTime(450),
//                 map(value => {
//                     if (value.remove)
//                         return this._basketService.deleteLine([this.id]);
//                     if (this.quantity > value.quantity || this.quantity < value.quantity)
//                         if (this.addons?.length > 0)
//                             return this._basketService.updateOrCreateLines({ groupLine: { sku: this.sku, quantity: value.quantity }, lines: this.addons.map(addon => ({ sku: addon.sku, quantity: value.quantity })) });
//                         else
//                             return this._basketService.updateOrCreateLine({ sku: this.sku, quantity: value.quantity });
//                     return of(null);
//                 }),
//                 switchMap(_ => _)
//             )
//             .subscribe());
//     }

//     updateForm(model: LineItemReturnModel) {
//         Object.assign(this, model);
//         if (this.get('quantity').value !== model.quantity) {
//             this.unsubscribe();
//             this.get('quantity').setValue(model.quantity);
//             this._subscribe();
//             this._detector.markForCheck();
//         }
//     }

//     unsubscribe() {
//         this._subscriptions.forEach(sub => {
//             if (sub != null && !sub.closed)
//                 sub.unsubscribe();
//         })
//     }
// }

// export class BasketForm extends FormGroup implements BasketReturnModel {
//     private _subscriptions: Subscription[];

//     useBillingAddressForShipping: boolean;
//     note?: string;
//     acceptNewsletter: boolean;
//     acceptTerms: boolean;
//     subtotal?: Money;
//     total?: Money;
//     shippingTotal?: Money;
//     totalVat?: Money;
//     shippingVat?: Money;
//     totalDiscount?: Money;
//     remainingTotal?: Money;
//     paidTotal?: Money;
//     estimatedShippingCost?: Money;
//     currency: string;
//     quantity: number;
//     paymentTerms?: PaymentTerms;
//     promoCodes: string[];
//     created: Date;
//     updated: Date;
//     disableEmailInvoice: boolean;
//     orderState?: string;
//     payments: PaymentReturnModel[];
//     shipments: ShipmentReturnModel[];
//     basketId: string;
//     id: string;
//     marketId: string;
//     lines: LineItemReturnModel[];
//     billingAddress: Address;
//     shippingAddress: Address;
//     lines$: Observable<LineItemReturnModel[]>;

//     constructor(basketService: BasketService, detector: ChangeDetectorRef) {
//         super({ lines: new FormGroup({}) });
//         this._subscriptions = [];
//         this.lines$ = basketService.basket$.pipe(
//             map(b => (b?.lines ?? []))
//         );
//         this._subscriptions.push(
//             basketService
//                 .basket$
//                 .subscribe(basket => {
//                     if (basket == null)
//                         return;
//                     basket.lines
//                         .forEach(line => {
//                             let form = this.get(['lines', line.id]) as BasketLineForm;
//                             if (form == null) {
//                                 form = new BasketLineForm(line, line.addons, basketService, detector);
//                                 (this.get('lines') as FormGroup).setControl(line.id, form);
//                             } else
//                                 form.updateForm(line);
//                         });
//                     Object.assign(this, basket);
//                     this.id = basket?.basketId ?? '';
//                     detector.markForCheck();
//                 })
//         );
//     }

//     unsubscribe() {
//         this._subscriptions.forEach(sub => {
//             if (sub != null && !sub.closed)
//                 sub.unsubscribe();
//         });
//         Object.values(this.controls)
//             .filter(c => c != null && 'unsubscribe' in c)
//             .forEach(c => (c as BasketLineForm).unsubscribe())
//     }
// }

@Injectable({
    providedIn: 'root'
})
export class BasketService implements OnDestroy {
    private _basket$: BehaviorSubject<BasketReturnModel>;
    private _shippingMethods$: BehaviorSubject<ShippingMethodReturnModel[]>;
    private _basketClient: BasketClient;
    private _linesClient: LinesClient;
    private _orderClient: OrderClient;

    private _broadcastChannel: BroadcastChannel;

    basket$: Observable<BasketReturnModel>;
    private _newsletterClient: NewsletterClient;

    get shippingMethods(): ShippingMethodReturnModel[] {
        return this._shippingMethods$.getValue();
    }
    get basket(): BasketReturnModel {
        return this._basket$.getValue();
    }
    get basketId(): string | null {
        return this._basket$?.getValue()?.basketId ?? null;
    }

    constructor(
        @Inject(LANGUAGE)
        private _catalog: string,
        @Inject(BASE_URL)
        baseUrl: string,
        private _contentCache: ContentCache,
        private translationService: TranslateService,

        private _ApplicationRef: ApplicationRef,
        @Inject(GOOGLE_MAPS_API_KEY)
        private googleMapsKey: string,
    ) {
        this._basketClient = new BasketClient(baseUrl);
        this._linesClient = new LinesClient(baseUrl);
        this._orderClient = new OrderClient(baseUrl);
        this._newsletterClient = new NewsletterClient(baseUrl);
        this._basket$ = new BehaviorSubject<BasketReturnModel>(null);
        this._shippingMethods$ = new BehaviorSubject<ShippingMethodReturnModel[]>([]);
        if ('BroadcastChannel' in window) {
            this._broadcastChannel = new BroadcastChannel("basket");
            this._broadcastChannel.onmessage = (msg) => {
                var basket: BasketReturnModel;
                var shippingMethods: ShippingMethodReturnModel[];
                var {
                    basket,
                    shippingMethods
                } = JSON.parse(msg.data) as { basket: BasketReturnModel, shippingMethods: ShippingMethodReturnModel[] };
                this._basket$.next(basket);
                this._shippingMethods$.next(shippingMethods);
                this._ApplicationRef.tick();
            };
        }
        this.basket$ = this._basket$.pipe(shareReplay(1));
        this.get();
    }

    ngOnDestroy(): void {
        if ('BroadcastChannel' in window) {
            this._broadcastChannel.close();
        }
    }

    getInquiryTypes(): Promise<{ id: string; value: string; name: string; }[]> {
        return PromiseUtils.cache(() => new Promise<{ id: string; value: string; name: string; }[]>(async (resolve, reject) => {
            resolve(Promise
                .all(
                    new Array(5)
                        .fill('INQUIRY.OPTIONS.OPTION')
                        .map((_, i) => this.translationService
                            .get(_ + (i + 1))
                            .toPromise()
                        )
                )
                .then(a => a.map((_, i) => ({
                    id: `${i + 1}`,
                    value: _,
                    name: _,
                })))

            )
        }), 'getInquiryTypes')
    }

    getCountries(): Promise<ICountry[]> {
        return Promise.resolve(countriesMock);
    }
    getCountry(): Promise<ICountry> {
        return this.getCountries().then(countries => {
            var code = this._catalog.toLowerCase().split('-').findLast(() => true);
            var country = countries.find(country => country.code.toLowerCase() === code);
            return country;
        })
    }

    async getOrder(orderId: string) {
        var fn = () => this._orderClient.getOrder(orderId, false);

        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        if (isDevMode())
            resp.isTracked = false
        const order = resp.orderReturn
        try {
            var ga4Event = MapToGA4.purchase(order);
            if (!resp.isTracked)
                GA4.purchase(ga4Event)
        } catch (e) {
            console.debug(e);
        }
        order.lines = this.mapOrderLines(order.lines);
        return order;
    }

    async deleteLine(ids: string[]) {
        const oldBasket = this.basket;
        var fn = () => this._linesClient.delete(this._catalog, ids, this?.basketId);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        try {
            var ga4Event = MapToGA4.deleteLine(resp, ids, oldBasket);
            GA4.track(ga4Event)
        } catch (e) {
            console.debug(e);
        }
        this._updateBasket(resp);
        return resp;
    }

    async get(basketId?: string): Promise<BasketResponseModel> {
        var fn = () => this._basketClient.get(this._catalog, basketId ?? this?.basketId ?? null);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        this._updateBasket(resp);
        return resp;
    }

    async deleteBasket(): Promise<void> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.deleteBasket(this._catalog, this?.basketId);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        try {
            var ga4Event = MapToGA4.deleteBasket(oldBasket);
            GA4.track(ga4Event);
        } catch (e) {
            console.debug(e);
        }
        await this._updateBasket(null);
        return resp;
    }

    async updateCustomer(requestBody: SetCustomerTypeRequestBody) {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateCustomer(this._catalog, this?.basketId, requestBody);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }

    async updateAddresses(addresses: UpdateBasketAddressModel): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateAddresses(this._catalog, this?.basketId, addresses);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }

    async updateCvr(cvr: string): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateCvr(this._catalog, this?.basketId, cvr);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }

    async updateGln(gln: string): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateGln(this._catalog, this?.basketId, gln);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }
    async updateInvoiceDetails(request: InvoiceDetailRequestModel): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateInvoiceDetails(this._catalog, this?.basketId, request);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }

    async updateNote(note?: string): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.updateNote(this._catalog, this?.basketId, note);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);

        await this._updateBasket(resp);
        return resp;
    }

    async setShipment(shipping?: UpdateShippingModel): Promise<BasketResponseModel> {
        const oldBasket = this.basket;
        var fn = () => this._basketClient.setShipment(this._catalog, this?.basketId, shipping);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        await this._updateBasket(resp);
        return resp;
    }

    async getShippingMethods(): Promise<ShippingMethodReturnModel[]> {
        var fn = () => this._basketClient.getShippingMethods(this._catalog, this?.basketId);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        return resp;
    }

    async getPickupPoints(provider: string, postalcode: string): Promise<PickupPoint[]> {
        var fn = () => this._basketClient.getPickupPoints(this._catalog, provider, postalcode, this?.basketId);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        return resp;
    }

    async updateOrCreateLines(itemsModel: AddBasketLineItemsModel) {
        const oldBasket = this.basket;
        var fn = () => this._linesClient.updateOrCreateLines(this._catalog, this?.basket?.basketId, itemsModel);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        try {
            var ga4Event = MapToGA4.updateOrCreateLines(resp, itemsModel, oldBasket);
            GA4.track(ga4Event);
        } catch (e) {
            console.debug(e);
        }
        await this._updateBasket(resp);
        return resp
    }

    async createLines(itemsModel: AddBasketLineItemsModel) {
        const oldBasket = this.basket;
        var fn = () => this._linesClient.createLines(this._catalog, this?.basket?.basketId, itemsModel);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        try {
            var ga4Event = MapToGA4.updateOrCreateLines(resp, itemsModel, oldBasket);
            GA4.track(ga4Event);
        } catch (e) {
            console.debug(e);
        }
        await this._updateBasket(resp);
        return resp
    }

    async updateOrCreateLine(itemsModel: AddLineItemModel) {
        const oldBasket = this.basket;
        var fn = () => this._linesClient.updateOrCreateLine(this._catalog, this?.basket?.basketId, itemsModel);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        try {
            var ga4Event = MapToGA4.updateOrCreateLine(resp, itemsModel, oldBasket);
            GA4.track(ga4Event);
        } catch (e) {
            console.debug(e);
        }
        await this._updateBasket(resp);
        return resp
    }

    async getPaymentMethods(): Promise<PaymentMethods> {
        var fn = () => this._basketClient.getPaymentMethods(this._catalog, this?.basketId)
        var paymentMethods = await PromiseUtils.retryWeb(fn);
        return paymentMethods.map(m => Object.assign({ ...m }, { id: m.id.replaceAll('/', '_'), }))
    }

    async setNewsLetter(accept: boolean, source: Origin, firstName?: string, lastName?: string, email?: string, phoneNumber?: string): Promise<BasketResponseModel> {
        ///
        firstName = firstName ?? this.basket.billingAddress.firstName,
            lastName = lastName ?? this.basket.billingAddress.lastName,
            email = email ?? this.basket.billingAddress.email;
        phoneNumber = phoneNumber ?? this.basket.billingAddress.phoneNumber
        if (accept)
            await this._newsletterClient.post(this._catalog, { email, firstName, lastName, phoneNumber, source } as NewsletterPostBody)
        return this.get(this?.basket?.basketId);
    }

    getPaymentExtras(): Array<{ alias: string, dialogLink: string, id: string, linkText: string, text: string, }> {
        return this._contentCache.get<CheckoutConfiguration>('checkout').extras;
    }

    async setAcceptTerms(
        accept: boolean,
        termid: string = '',
    ): Promise<BasketResponseModel> {
        var fn = () => this._basketClient.setAcceptTerms(this._catalog, this?.basketId, accept);
        var _fn = fn;
        var resp = await PromiseUtils.retryWeb(_fn);
        this._updateBasket(resp);
        return resp;
    }

    async purchase(paymentMethodId: string): Promise<string> {
        return new Promise<string>(async (resolve, reject) => {

            var fn = () => this._basketClient.getPaymentUrl(this._catalog, this?.basketId, paymentMethodId);
            var _fn = fn;
            var paymentUrl = await PromiseUtils.retryWeb(_fn).catch(msg => reject(msg));

            if (!paymentUrl)
                reject(new Error('No Response'));
            resolve(paymentUrl as string);
        });
    }

    async getCityByAddress(address: string): Promise<string> {
        var _url = new URL('https://maps.googleapis.com/maps/api/geocode/json');
        _url.searchParams.append('key', this.googleMapsKey);
        _url.searchParams.append('sensor', 'true');
        _url.searchParams.append('address', address);
        const response = await fetch(_url);
        const msg = await response.json()
        // fail silently
        // if (response.status !== 200 || msg.status !== 'OK') {
        //     this.notificationService.next({
        //         title: msg.status,
        //         text: msg.error_message,
        //         color: 'var(--error-color, white)',
        //         backgroundColor: 'var(--error-background-color, red)',
        //         position: 'top-mid',
        //         duration: 5000
        //     } as NotificationModel);
        //     return '';
        // }
        let city: string;
        var country = this._catalog.split('-').find((_, i, a) => i + 1 === a.length);
        var section = msg?.results?.find(r => r.address_components.some(c => c?.short_name?.toLowerCase() === country?.toLowerCase()));
        var component = section?.address_components?.find(component => component?.types?.includes('locality'));
        city = component?.long_name ?? '';
        return city;
    }

    private async _updateBasket(response: BasketResponseModel): Promise<BasketResponseModel> {
        response.basketReturn.lines = this.mapBasketLines(response.basketReturn.lines);
        this._basket$.next(response.basketReturn);
        this._shippingMethods$.next(response.shippingMethods);

        if (this._broadcastChannel)
            this._broadcastChannel.postMessage(JSON.stringify({ ...response }))
        return response;
    }

    private mapBasketLines(lines: LineItemReturnModel[]): LineItemReturnModel[] {
        return lines.map((line, _, lines) => {
            if (line.parentId != null)
                return;
            const children = lines.filter(_line => _line.parentId === line.id);
            var query = new URLSearchParams();
            [line.sku, ...children.map(c => c.sku)].forEach(sku => {
                var [id, variation] = sku.split(',')
                if (variation)
                    query.set(UrlUtil.VARIATION_PREFIX + id, variation);
            });
            query.set(UrlUtil.REPLACE_PREFIX, line.id);
            line.productUrl = SerializerUtil.serialize(UrlUtil.safeUrl(query, new URL(line.productUrl, window.origin)));
            line.addons = children;
            return line;
        })
            .filter(_ => _);
    }
    private mapOrderLines(lines: LineItemReturnModel[]): LineItemReturnModel[] {
        return lines.map((line, _, lines) => {
            if (line.parentId != null)
                return;
            const children = lines.filter(_line => _line.parentId === line.id);
            var query = new URLSearchParams();
            [line.sku, ...children.map(c => c.sku)].forEach(sku => {
                var [id, variation] = sku.split(',')
                if (variation)
                    query.set(UrlUtil.VARIATION_PREFIX + id, variation);
            });
            query.set(UrlUtil.REPLACE_PREFIX, line.id);
            line.productUrl = SerializerUtil.serialize(UrlUtil.safeUrl(query, new URL(line.productUrl, window.origin)));
            line.addons = children;
            return line;
        })
            .filter(_ => _);
    }
}


